import React from 'react'
import '../../Css/Savani.css'
import kalathiya from '../../Image/kalathiya_txt.svg'
import insta from '../../Image/insta.svg'
import face from '../../Image/face.svg'
import google from '../../Image/about_google.svg'
import linkdin from '../../Image/about_linkdin.svg'
import youtube from '../../Image/youtube.svg'

const ContactHead = () => {
    const socialIcons = [
        { src: face, alt: 'Facebook', link: "https://www.facebook.com/kalathiyainfotech", active: true },
        { src: insta, alt: 'Instagram', link: "https://www.instagram.com/kalathiya_infotech/" },
        { src: google, alt: 'Google', link: "https://www.google.com/search?q=kalathiya+infotech&rlz=1C1GCEA_enIN1018IN1018&oq=Kalathiya+&aqs=chrome.0.69i59l2j69i57j69i59j69i60l4.17467j0j7&sourceid=chrome&ie=UTF-8" },
        { src: linkdin, alt: 'LinkedIn', link: "https://www.linkedin.com/company/kalathiyainfotech/" },
        { src: youtube, alt: 'YouTube', link: "https://www.youtube.com/@KalathiyaInfotech" },
    ];
    return (
        <>
            <div>
                <section>
                    <div className='bg-[#F6F6F6] '>
                        <div className='container'>
                            <div className='lg:hidden block'>
                                <div className='flex pt-4'>
                                    {socialIcons?.map((icon, index) => (
                                        <div key={index} className={`ds_round flex justify-center custom_hover align-middle me-3 `}>
                                            <img src={icon?.src} alt={icon?.alt} className='ds_round_svg' />
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className='md:pt-[130px] pt-[80px] container relative '>
                                <h2 className="md:text-[60px] sm:text-[40px] sx:text-[30px] text-[28px] font-[700] text-theme_dark text-center">Contact Us</h2>
                                <div className='flex justify-center mt-4 relative sm:top-[20px] top-[10px]'><img src={kalathiya} alt="" /></div>
                                <div className='lg:block hidden'>
                                    <div className='absolute top-[20%] right-0  flex flex-col justify-center'>
                                        <div>
                                            {socialIcons?.map((icon, index) => (
                                                <div key={index} className={`ds_round flex justify-center custom_hover align-middle mb-2`}>
                                                    <a href={icon?.link} target='_blank' rel="noreferrer"><img src={icon?.src} alt={icon?.alt} className='ds_round_svg' /></a>
                                                </div>
                                            ))}
                                        </div>
                                        <div className='lg:block hidden'>
                                            <div className='flex justify-center mt-3 '>
                                                <div className='w-[1px] h-[80px] bg-theme_dark'></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    )
}

export default ContactHead